import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./GroupsPage.module.css";
import { useAddGroup } from "./useGroups";

import Header from "DreamStream/Shared/Header";
import { OptionsDropdown } from "../Shared/OptionsDropdown/OptionsDropdown";
import GroupsList from "./GroupsList";
import Card from "../../shared/Card";

import DeleteAllHistoryModal from "./DeleteAllHistoryModal";
import DeleteEmptyGroupsModal from "./DeleteEmptyGroupsModal";
import ConfirmationModal from "DreamStream/Shared/ConfirmationModal";
import CreateGroupModal from "./CreateGroupModal";
import SearchBar from "DreamStream/Shared/SearchBar";
import Loader from "shared/Loader";

import { useGroups } from "./useGroups";

export const RECENT_IBOS_KEY = "membership.recentibos";

export function GroupsPage() {
  const history = useHistory();

  const { data: groups, refetch } = useGroups("groups");

  var formattedGroups = []; // because "groups" is actually "organizations", so this is the "real" groups

  const [groupsState, setGroupsState] = useState(null);
  const [originalGroups, setOriginalGroups] = useState([]);
  const [deleteHistoryModalOpen, setDeleteHistoryModalOpen] = useState(false);
  const [createMissingLOSGroupModalOpen, setCreateMissingLOSGroupModalOpen] =
    useState(false);
  const [deleteEmptyGroupsModalOpen, setDeleteEmptyGroupsModalOpen] =
    useState(false);
  const [createGroupModalOpen, setCreateGroupModalOpen] = useState(false);

  const { groupInfo } = {};

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (groups) {
      formattedGroups = [];
      for (var o = 0; o < groups.length; o++) {
        for (var g = 0; g < groups[o].groups.length; g++) {
          var orgName = "";
          if (groups[o].pinLevel === 0) {
            var n = groups[o].name.split(" ");
            orgName = n[n.length - 1];
          } else {
            orgName = groups[o].organizationName;
          }
          const groupInfo = {
            organization: orgName,
            groupName: groups[o].groups[g].groupName,
            groupId: groups[o].groups[g].groupId,
            organizationId: groups[o].organizationId,
            pinLevel: groups[o].pinLevel,
            iboNumber: groups[o].iboNumber,
            name: groups[o].name,
            id: groups[o]._id,
          };
          formattedGroups.push(groupInfo);
        }
      }
      setGroupsState(formattedGroups);
      setOriginalGroups(formattedGroups);
    }
  }, [groups]);

  var groupTypes = [];
  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      if (!groupTypes.includes(groups[i].groupType)) {
        groupTypes.push(groups[i].groupType);
      }
    }
  }

  function handleOptionsDropdown(option) {
    switch (option) {
      case "Delete History":
        setDeleteHistoryModalOpen(true);
        break;
      case "Global Admins":
        history.push("/dreamstream/global-admins");
      case "Create Group":
        setCreateGroupModalOpen(true);
        break;
    }
  }

  function deleteAllHistory(continueBool) {
    // TODO: put api call here
    setDeleteHistoryModalOpen(false);
    alert("deleteAllHistory called with: " + continueBool);
  }

  function deleteEmptyGroups() {
    // TODO: put api call here
    setDeleteEmptyGroupsModalOpen(false);
    alert("deleteEmptyGroups called");
  }

  function createMissingLOSGroups() {
    // TODO: put api call here
    setCreateMissingLOSGroupModalOpen(false);
    alert("createMissingLOSGroups called");
  }

  // Add new group
  const { addGroup } = useAddGroup();

  async function createGroup(groupInfo) {
    addGroup.mutateAsync(groupInfo).then(() => {
      refetch();
    });

    setIsLoading(true);
    closeLoader();
    setCreateGroupModalOpen(false);
  }

  const closeLoader = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  };

  function onSearch(searchText) {
    let newGroups = originalGroups;

    let term = searchText.toString().trim().toLowerCase();

    if (term !== "") {
      newGroups = newGroups.filter(function (group) {
        let isMatch =
          group.iboNumber.toString().toLowerCase().includes(term) ||
          (group.organization ? group.organization : "")
            .toLowerCase()
            .includes(term) ||
          group.groupName.toLowerCase().includes(term);

        //Filter by group type
        if (term === "non-los" && group.pinLevel === 0) {
          isMatch = true;
        } else if (term === "los" && group.pinLevel !== 0) {
          isMatch = true;
        } else if (group.pinLevel.toString().toLowerCase().includes(term)) {
          isMatch = true;
        }
        return isMatch;
      });
      setGroupsState(newGroups);
    } else {
      setGroupsState(originalGroups);
    }
  }

  return (
    <div className={styles.container}>
      <Header
        title="ORGANIZATION GROUPS"
        children={
          <div className={styles.options}>
            <OptionsDropdown
              options={[/*"Delete History", "Global Admins",*/ "Create Group"]}
              placeholder={"OPTIONS"}
              openedPlaceholder={"SELECT"}
              onChange={handleOptionsDropdown}
            ></OptionsDropdown>
          </div>
        }
        back={false}
      />

      <div className={styles.subHeader}>
        Groups is used to display a list of LOS Groups that are currently in
        use. Groups also provides the ability to create Non-LOS groups. Non-LOS
        groups are populate via the Plugins sections.
      </div>
      {/* <Header title="ORGANIZATION GROUPS" />
      <div className={styles.headerContainer}></div> */}
      <Card className={styles.cardContainer}>
        <div className={styles.header}>GROUPS</div>
        <SearchBar
          onInput={(searchText) => onSearch(searchText)}
          placeholderText="Search by Plugin ID, IBO Name, or Group Name"
          searchDelay={0}
          minChar={0}
          className={styles["search-bar"]}
          btn={true}
        />
        {isLoading ? (
          <Loader />
        ) : groupsState !== null ? (
          <GroupsList groups={groupsState} />
        ) : (
          <Loader />
        )}
      </Card>

      <DeleteAllHistoryModal
        isOpen={deleteHistoryModalOpen}
        onClose={() => setDeleteHistoryModalOpen(false)}
        onClick={deleteAllHistory}
        continueBool={false}
      />

      <DeleteEmptyGroupsModal
        groupsList={groups}
        header="DELETE EMPTY GROUPS"
        description="Are you sure you would like to delete all groups with no members? This action cannot be undone."
        btnName="DELETE ALL"
        isOpen={deleteEmptyGroupsModalOpen}
        onClose={() => setDeleteEmptyGroupsModalOpen(false)}
        onClick={() => deleteEmptyGroups()}
      />

      <ConfirmationModal
        isOpen={createMissingLOSGroupModalOpen}
        onClose={() => setCreateMissingLOSGroupModalOpen(false)}
        onClick={createMissingLOSGroups}
        header="Create Missing LOS Groups"
        description="Clicking create will create [ # ] missing LOS groups for Platinums, Emeralds, and Diamonds."
        btnName="Create"
      />

      <CreateGroupModal
        isOpen={createGroupModalOpen}
        onClose={() => setCreateGroupModalOpen(false)}
        onClick={createGroup}
        groups={groups}
      />
    </div>
  );
}
